import { useEffect, useState } from "react";
import { BASE_ROUTE, HEADERS, setBaseUrl, setFeatureFlags } from "global/constants"


export default function useApiConfig () {

  const [message, setMessage] = useState("");
  const [configReady, setConfigReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const callApiConfig = async () => {
      try {
        const response = await fetch(`${BASE_ROUTE}/config`, {
          method: "GET",
          headers: HEADERS,
        });
        if (cancelled) return;
        if (!response.ok) {
          setMessage(null);
          setFeatureFlags({});
          return;
        }
        const data = await response.json();
        if (cancelled) return;
        setMessage(data.message);
        setBaseUrl(data.base_url);
        setFeatureFlags(data.feature_flags ?? {});
      } catch {
        if (!cancelled) {
          setMessage(null);
          setFeatureFlags({});
        }
      } finally {
        if (!cancelled) setConfigReady(true);
      }
    };

    callApiConfig();
    return () => {
      cancelled = true;
    };
  }, []);

  return { message, configReady };

};